import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import { companies } from './views/Company/company.routes'
import { unitTypes } from './views/unitTypes/unitTypes.routes'
import { tests } from './views/tests/tests.routes'
import { units } from './views/units/units.routes'
import { sites } from './views/sites/sites.routes'
import { subscriptions } from './views/subscriptions/subscriptions.routes'
import { users } from './views/users/users.routes'
import { permissions } from './views/permissions/permissions.routes'
import { inspections } from './views/inspections/inspections.routes'
import { history } from './views/history/history.routes'
import { reports } from './views/reports/reports.routes'
import { contacts } from './views/contacts/contacts.routes'
import { monitor } from './views/monitoring/monitoring.routes'
import { incidents } from './views/reportsIncidents/incidents.routes'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path:'/',
      component: () => import('./layouts/Dashboard.vue'),
      children: [
        {
          path: '/notifications',
          name: 'notifications',
          component: () => import('./views/notifications/notifications'),
          meta: {
            rule: 'NOTIFICATIONS',
            title: 'general.notifications',
            breadcrumb: [
              {
                text: 'general.home',
                disabled: false,
                href: '/',
              },
              {
                text: 'general.notifications',
                disabled: true,
                href: '/notifications',
              }
            ]
          }
        },
        {
          path: '/',
          name: 'Dashboard',
          component: () => import('./views/Dashboard.vue'),
          // beforeEnter: requireAuth,
          meta: {
            authRequired: true,
            rule: 'DASHBOARD',
            title: 'general.home', // utilizar nombre de la etiqueta i18n
            breadcrumb: []
          }
        },
        ...companies,
        ...unitTypes,
        ...tests,
        ...subscriptions,
        ...users,
        ...units,
        ...sites,
        ...permissions,
        ...inspections,
        ...history,
        ...reports,
        ...contacts,
        ...monitor,
        ...incidents
      ]
    },
    {
      path: '/auth',
      component: () => import('./layouts/Auth'),
      children: [
        {
          path: 'login',
          name: 'login',
          meta: {
            authRequired: false
          },
          component: () => import('./views/login/Login')
        },
        {
          path: 'recover',
          name: 'recover',
          meta: {
            authRequired: false
          },
          component: () => import('./views/recoverPassword/RecoverPassword')
        },
        {
          path: 'reset',
          name: 'reset',
          meta: {
            authRequired: false
          },
          component: () => import('./views/newPassword/NewPassword')
        },
        // {
        //   path: 'registration',
        //   name: 'registration',
        //   meta: {
        //     authRequired: false
        //   },
        //   component: () => import('./views/wizardRegistration/WizardRegistration')
        // },
        {
          path: '',
          // name: 'pageNotFound',
          component: () => import('./layouts/PageNotFound')
        }
      ]
    },
    {
      path: '*',
      name: 'pageNotFound',
      component: () => import('./layouts/PageNotFound')
    }
  ]
})

export default router

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token') && to.meta.authRequired === false) {
    next('/')
  } else if (!localStorage.getItem('token') && to.meta.authRequired) {
    next ('/auth/login')
  } else {
    return next()
  }
})

router.afterEach((to, from, next) => {
  let permissions = store.state.userLogged.allPermissions ? store.state.userLogged.allPermissions : []
  if (permissions.length > 0 && !permissions.find(item => item === to.meta.rule)) {
    router.push('/')
  }
})
